module.exports = __webpack_public_path__ + "img/UKC-1916.46802263.png";